export const normalizeCreateTextAssignmentFromZipResponse = response => ({
    id: response.version_id,
    rejectedFileNames: response.rejected_files,
})

export const normalizeAddFilesToAssignmentResponse = response => ({
    rejectedFileNames: response?.rejected_files,
})

const normalizeAssignmentShort = assignment => ({
    id: assignment.assignment_id,
    name: assignment.assignment_name,
    token: assignment.token,
    defaultLayerId: assignment.default_layer_id,
    type: assignment.assignment_type,
    sharingLevel: assignment.sharing_level,
    permissionLevel: assignment.permission_level,
    language: assignment.language,
})

export const normalizeSearchAssignmentsResponse = response => ({
    assignments: response.my_assignments.map(normalizeAssignmentShort),
    sharedAssignments: response.shared_assignments.map(normalizeAssignmentShort),
})

export const normalizeFetchAssignmentFiltersResponse = response => ({
    languages: response.languages,
    courses: response.courses?.map(course => ({
        id: course.id,
        name: course.course_name,
    })) || [],
    organizations: response.organizations?.map(organization => ({
        id: organization.account_id,
        name: organization.account_name,
    })) || [],
    types: response.assignment_types?.map(type => type.id) || [],
    owners: response.owners || [],
})
